import React from 'react';
import CropImg from '../../../../images/crop.svg';

const Location = ({ location }) => {
  return (
    <div className="flex mt-2 items-center">
      <div className="w-1/4">
        <img src={CropImg} alt="CropImg" />
      </div>
      <div className="w-3/4">
        <div className="flex">
          <div className="w-1/2">
            <div className="bg-cf-100 py-6 px-3 rounded text-center h-32">
              <p className="text-sm font-bold">Location</p>
              <p>
                Your farm is located in {location.name}, {location.state} of {location.country}.{' '}
              </p>
            </div>
          </div>
          <div className="w-1/2">
            <div className="bg-gray-100 py-1 px-2 rounded">
              <p className="text-sm font-bold mb-2">Location Benefits</p>
              <div className="flex">
                <div className="rounded-full h-6 w-6 bg-gray-300"></div>
                <div className="ml-2">
                  <p>Good weather</p>
                  <div className="border-b-4 border-cf-300 w-20"></div>
                </div>
              </div>

              <div className="flex mt-1">
                <div className="rounded-full h-6 w-6 bg-gray-300"></div>
                <div className="ml-2">
                  <p>Good Soil</p>
                  <div className="border-b-4 border-cf-300 w-20"></div>
                </div>
              </div>

              {/* <div className="flex mt-1 mb-1">
                <div className="rounded-full h-6 w-6 bg-gray-300"></div>
                <div className="ml-2">
                  <p>Hardworking</p>
                  <div className="border-b-4 border-cf-300 w-20"></div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Location;
